/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const LimitedApp56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <circle cx={48} cy={8} r={8} fill={vars.bdlBoxBlue10} />
            <circle cx={4} cy={52} r={4} fill={vars.bdlBoxBlue10} />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M39 7H17c-5.43 0-9.848 4.327-9.997 9.72L7 17v22c0 5.43 4.326 9.848 9.72 9.996L17 49h22c5.429 0 9.848-4.327 9.996-9.72L49 39V17c0-5.43-4.327-9.848-9.72-9.996L39 7z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M39 5c6.627 0 12 5.373 12 12v22c0 6.627-5.373 12-12 12H17c-6.628 0-12-5.373-12-12V17c0-6.627 5.372-12 12-12h22zm0 2H17c-5.43 0-9.848 4.327-9.997 9.72L7 17v22c0 5.43 4.326 9.848 9.72 9.996L17 49h22c5.429 0 9.848-4.327 9.996-9.72L49 39V17c0-5.43-4.327-9.848-9.72-9.996L39 7zm-7 10c1.18 0 2.507.139 3.5.664l.038.022.081.055c.16.127.281.359-.119.759l-3 3a.707.707 0 101 1l3-3c.5-.5.757-.225.863 0 .463.987.637 2.412.637 3.5a6 6 0 01-5.775 5.996L32 29h-.585l1.745 1.745.416-.44c.4-.39 1.042-.408 1.464-.04l5.604 4.882c.405.353.469.94.168 1.365l-2.938 3.15a1.085 1.085 0 01-1.506.066l-5.07-5.554c-.39-.41-.405-1.05 0-1.446l.492-.523-2.484-2.484L19.65 39.74c-.36.36-.91.33-1.302.024l-3.068-3.057a1 1 0 01-.058-1.321l10.057-9.692-3.938-3.938-.035.032a1.019 1.019 0 01-1.498-.286l-1.662-2.778a1.03 1.03 0 01.156-1.258l.169-.168c.33-.33.841-.393 1.242-.154l2.787 1.663a1.03 1.03 0 01.262 1.541L26 23.586V23c0-3.303 2.697-6 6-6z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M31.425 19.015c-1.939.05-3.33 1.793-3.427 3.763l-.005.215.007 2c.002.486-.185 1.143-.5 1.507l-10 9.5 1.5 1.5 9.5-10c.335-.346.845-.449 1.32-.492L30 27h1.936l.188-.003c1.957-.072 3.573-1.506 3.84-3.395.016-.117.036-.602-.35-.256l-1.245 1.112a2 2 0 01-2.659.07l-.124-.114-1-1a2 2 0 01-.122-2.695l.116-.127 1.09-1.221c.22-.247.138-.366-.245-.356zM34.37 32.469l-1.048 1.022 3.756 3.935 1.341-1.43z"
            />
        </g>
    </AccessibleSVG>
);

export default LimitedApp56;
